import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ReactComponent as NoDataIcon } from "../../assets/images/NOData.svg";
import { CreateFormTheme } from '../../utils/themes';
import { useTheme } from '../../middleware/ThemeContext';
import NoFieldsStateIcon from '../../assets/icons/NoFieldsStateIcon';

type NoDataProps = {
  title: string;
  subtitle?: string;
  imageAlt?: string;
  isField?: boolean;
  containerHeight?: number;
  filterHeight?: number;
};

// Styled Components
const Container = styled.div<{ containerHeight?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ containerHeight }) => `calc(100vh - ${containerHeight})`};
  text-align: center;
  padding: 2rem;
  color: #6c757d;
`;

const Image = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 1.5rem;
  margin-top: 3.5rem;
  display: block;
`;

const Title = styled('h2')(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 700,
  fontFamily: "'Raleway', sans-serif",
  marginBottom: '0.5rem',
  color: theme.CreateFormTheme.colors.primary,
}));

const Subtitle = styled('p')(({ theme }) => ({
  fontSize: '16px',
  color: theme.CreateFormTheme.colors.textSecondary,
  fontWeight: 400,
  fontFamily: "'Raleway', sans-serif",
  maxWidth: '470px',
  textAlign: 'center',
}));

// ForwardRef Component
const NoData = forwardRef<HTMLDivElement, NoDataProps>(({ title, subtitle, imageAlt = 'No Data', isField = false, containerHeight = 270, filterHeight = 0 }, ref) => {
  const { theme } = useTheme();

  return (
    <Container ref={ref} containerHeight={`${containerHeight + filterHeight}px`}>
      {isField ?
        <NoFieldsStateIcon
          style={{
            marginBottom: "1.5rem",
            marginTop: "3.5rem",
            width: "150px",
            height: "150"
          }}
        />
        :
        <div>
          <NoDataIcon
          aria-label={imageAlt}
          style={{
            width: "245px",
            height: "196px",
            marginBottom: "1.5rem",
            marginTop: "3.5rem",
          }}
        />
        </div>
      }
      <Title theme={theme}>{title}</Title>
      {subtitle && <Subtitle theme={theme}>{subtitle}</Subtitle>}
    </Container>
  );
});

export default NoData;
